import React from 'react';
import { Hero, COEUR_PATH_UNIT } from '../components/HeroCarousel';
import { QuickAccess } from '../components/QuickAccess';
import { News } from '../components/News';
import { Events } from '../components/Events';
interface AccueilProps {
  showEvents?: boolean;
}
export function Accueil({
  showEvents = true
}: AccueilProps) {
  return <main data-id="element-1952" data-mp="s2pvnvdv476j">
      {/* Trace du coeur, rendu une seule fois : la classe .coeur-mask le reference. */}
      <svg width="0" height="0" aria-hidden="true" className="absolute" data-id="element-1953" data-mp="n5pnnexgcucs">
        <defs data-id="element-1954" data-mp="i40c7y6bieo6">
          <clipPath id="coeur-mask" clipPathUnits="objectBoundingBox" data-id="element-1955" data-mp="i3gv2johrub7">
            <path d={COEUR_PATH_UNIT} data-id="element-1956" data-mp="d570aa6oivq4" />
          </clipPath>
        </defs>
      </svg>

      <Hero data-id="element-1957" data-mp="94vgezm54zfp" />
      <QuickAccess data-id="element-1958" data-mp="9559wx6e9oq5" />
      <News data-id="element-1959" data-mp="95onk1p0hqyd" />
      {showEvents && <Events data-id="element-1960" data-mp="96g7ugd5s29c" />}
    </main>;
}